export const SITE_URL = 'https://iridiachat.com'

export interface FaqEntry {
  question: string
  answer: string
}

/** Datos estructurados FAQPage (schema.org) a partir de las preguntas visibles en el home. */
export function buildFaqJsonLd(items: readonly FaqEntry[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: { '@type': 'Answer', text: item.answer },
    })),
  }
}

/** Serializa JSON-LD para incrustarlo en un <script>: `<` escapado evita cerrar la etiqueta. */
export function serializeJsonLd(data: unknown): string {
  return JSON.stringify(data).replace(/</g, '\\u003c')
}
